<script setup>
import { useRouter } from 'vue-router'
import { useStorage } from "@vueuse/core"
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const version = useStorage('version', new Map())
const router = useRouter()
const handleUpdate = () => {
  localStorage.clear()
  sessionStorage.clear()
  window.location.reload()
}
onMounted(() => {
  if (version.value.size == 0) {
    router.push('/')
  }
})
onUnmounted(() => {
  handleUpdate()
})
</script>

<template>
  <div class="overflow-hidden">
    <div class="w-full h-screen flex items-center justify-center">
      <div class="relative w-full  h-1/3">
        <div class="absolute z-1 top-0 left-0 w-full flex justify-center">
          <img class="w-2/3 h-auto" src="@/assets/404/update.png" alt="" srcset="">
        </div>
        <div class="absolute z-2 -bottom-[20px] w-full flex items-center justify-center flex-wrap">
          <div class="flex items-center justify-center ">
            <div class="max-w-3.5/5 text-[13px] lh-[2em] text-white text-center whitespace-wrap">
              {{ t('update.update') }}
            </div>
          </div>
          <div class="mt-[30px] flex items-center justify-center">
            <div style="box-shadow: 1px 1px 2px 0px rgba(21,76,55,0.32)" @click="handleUpdate" class="px-[20px] h-[40px] text-[14px] p-[10px]  bg-[linear-gradient(0deg,#399958,#43C36B)] text-white rounded-[6px]">
              {{ t('update.updateNow') }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped></style>
<route lang="json5">
  {
    name: 'update',
    meta: {
      title: '更新',
      i18n: 'menus.update'
    },
  }
</route>
